import React from "react";

const CE = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Rota /extrato funcionando ✅</h1>
    </div>
  );
};

export default CE;
